import script from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"
export * from "./PoolFees.vue?vue&type=script&lang=ts&setup=true"

import "./PoolFees.vue?vue&type=style&index=0&id=48fb7706&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48fb7706"]])

export default __exports__